var HTMLData_Source = /* @__PURE__ */ ((HTMLData_Source2) => {
  HTMLData_Source2["HTML"] = "HTML";
  HTMLData_Source2["ADSENSE"] = "ADSENSE";
  HTMLData_Source2["AI"] = "AI";
  HTMLData_Source2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return HTMLData_Source2;
})(HTMLData_Source || {});
export {
  HTMLData_Source
};
//# sourceMappingURL=plugin_html.enums.js.map
